import SelectorOption from '@components/SelectorOption';
import { FinancialProductType, LeaselinkOffer } from 'types/models/LeaselinkOffer';

import classes from './LeaselinkOptions.module.scss';

type LeaselinkOptionsType = 'NumberOfInstallments' | 'PercentInitialFee' | 'PercentResidualFee';

type Props = {
  offersPerType: Record<FinancialProductType, LeaselinkOffer[]>;
  activeOffer: LeaselinkOffer;
  type: LeaselinkOptionsType;
  onClick: (id: string) => void;
};

const leaselinkOptionsTypes: LeaselinkOptionsType[] = [
  'NumberOfInstallments',
  'PercentInitialFee',
  'PercentResidualFee',
];

const valueTransformers: Record<LeaselinkOptionsType, (value: number) => string | number> = {
  NumberOfInstallments: (v) => v,
  PercentInitialFee: (v) => `${v}%`,
  PercentResidualFee: (v) => `${v}%`,
};

const LeaselinkOptions = ({ offersPerType, activeOffer, type, onClick }: Props) => {
  const restOptionsTypes = leaselinkOptionsTypes.filter((key) => key !== type);

  return (
    <div className={classes.container}>
      {offersPerType[activeOffer.FinancialProductType]
        .filter((offer) => restOptionsTypes.every((key) => offer[key] === activeOffer[key]))
        .toSorted((a, b) => a[type] - b[type])
        .map((offer) => (
          <SelectorOption
            isSelected={activeOffer.CalculationPackageId === offer.CalculationPackageId}
            key={offer.CalculationPackageId}
            onClick={() => onClick(offer.CalculationPackageId)}
          >
            {valueTransformers[type](offer[type])}
          </SelectorOption>
        ))}
    </div>
  );
};

export default LeaselinkOptions;
